module.exports = __webpack_public_path__ + "static/media/kyrgyzstan-large.98db905e.jpg";